import { render, staticRenderFns } from "./list-device-service-config.vue?vue&type=template&id=524f2f80&scoped=true"
import script from "./list-device-service-config.vue?vue&type=script&lang=js"
export * from "./list-device-service-config.vue?vue&type=script&lang=js"
import style0 from "./list-device-service-config.vue?vue&type=style&index=0&id=524f2f80&prod&scoped=true&lang=css"
import style1 from "./list-device-service-config.vue?vue&type=style&index=1&id=524f2f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f2f80",
  null
  
)

export default component.exports